import React from 'react';
import propTypes from 'prop-types';
import { ButtonWaitingPromise } from 'client/components/Button/ButtonWaiting';

export default class MWTDPanel extends React.Component {

  static propTypes = {
    onCall: propTypes.func.isRequired,
  };

  render () {
    const { onCall } = this.props;
    return (
      <div>
        <div>
          <ButtonWaitingPromise onClick={ev => onCall('syncInstanceDevices')} type="button" className="btn btn-default">
            Synchronize Devices/Assets
          </ButtonWaitingPromise>{' '}
        </div>
      </div>
    );
  }

}
